<template>
</template>

<script>
export default {
    name : 'TicketWidgetNewCenterContent',

    mounted() {
        window.showTicketNewCenterContentManual();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetNewCenterContent.vue